import { __assign, __extends } from "tslib";
import { SENSITIVE_STRING } from "@aws-sdk/smithy-client";
import { LambdaServiceException as __BaseException } from "./LambdaServiceException";
var InvalidParameterValueException = (function (_super) {
    __extends(InvalidParameterValueException, _super);
    function InvalidParameterValueException(opts) {
        var _this = _super.call(this, __assign({ name: "InvalidParameterValueException", $fault: "client" }, opts)) || this;
        _this.name = "InvalidParameterValueException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, InvalidParameterValueException.prototype);
        _this.Type = opts.Type;
        return _this;
    }
    return InvalidParameterValueException;
}(__BaseException));
export { InvalidParameterValueException };
var PolicyLengthExceededException = (function (_super) {
    __extends(PolicyLengthExceededException, _super);
    function PolicyLengthExceededException(opts) {
        var _this = _super.call(this, __assign({ name: "PolicyLengthExceededException", $fault: "client" }, opts)) || this;
        _this.name = "PolicyLengthExceededException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, PolicyLengthExceededException.prototype);
        _this.Type = opts.Type;
        return _this;
    }
    return PolicyLengthExceededException;
}(__BaseException));
export { PolicyLengthExceededException };
var PreconditionFailedException = (function (_super) {
    __extends(PreconditionFailedException, _super);
    function PreconditionFailedException(opts) {
        var _this = _super.call(this, __assign({ name: "PreconditionFailedException", $fault: "client" }, opts)) || this;
        _this.name = "PreconditionFailedException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, PreconditionFailedException.prototype);
        _this.Type = opts.Type;
        return _this;
    }
    return PreconditionFailedException;
}(__BaseException));
export { PreconditionFailedException };
var ResourceConflictException = (function (_super) {
    __extends(ResourceConflictException, _super);
    function ResourceConflictException(opts) {
        var _this = _super.call(this, __assign({ name: "ResourceConflictException", $fault: "client" }, opts)) || this;
        _this.name = "ResourceConflictException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, ResourceConflictException.prototype);
        _this.Type = opts.Type;
        return _this;
    }
    return ResourceConflictException;
}(__BaseException));
export { ResourceConflictException };
var ResourceNotFoundException = (function (_super) {
    __extends(ResourceNotFoundException, _super);
    function ResourceNotFoundException(opts) {
        var _this = _super.call(this, __assign({ name: "ResourceNotFoundException", $fault: "client" }, opts)) || this;
        _this.name = "ResourceNotFoundException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, ResourceNotFoundException.prototype);
        _this.Type = opts.Type;
        _this.Message = opts.Message;
        return _this;
    }
    return ResourceNotFoundException;
}(__BaseException));
export { ResourceNotFoundException };
var ServiceException = (function (_super) {
    __extends(ServiceException, _super);
    function ServiceException(opts) {
        var _this = _super.call(this, __assign({ name: "ServiceException", $fault: "server" }, opts)) || this;
        _this.name = "ServiceException";
        _this.$fault = "server";
        Object.setPrototypeOf(_this, ServiceException.prototype);
        _this.Type = opts.Type;
        _this.Message = opts.Message;
        return _this;
    }
    return ServiceException;
}(__BaseException));
export { ServiceException };
export var ThrottleReason;
(function (ThrottleReason) {
    ThrottleReason["CallerRateLimitExceeded"] = "CallerRateLimitExceeded";
    ThrottleReason["ConcurrentInvocationLimitExceeded"] = "ConcurrentInvocationLimitExceeded";
    ThrottleReason["FunctionInvocationRateLimitExceeded"] = "FunctionInvocationRateLimitExceeded";
    ThrottleReason["ReservedFunctionConcurrentInvocationLimitExceeded"] = "ReservedFunctionConcurrentInvocationLimitExceeded";
    ThrottleReason["ReservedFunctionInvocationRateLimitExceeded"] = "ReservedFunctionInvocationRateLimitExceeded";
})(ThrottleReason || (ThrottleReason = {}));
var TooManyRequestsException = (function (_super) {
    __extends(TooManyRequestsException, _super);
    function TooManyRequestsException(opts) {
        var _this = _super.call(this, __assign({ name: "TooManyRequestsException", $fault: "client" }, opts)) || this;
        _this.name = "TooManyRequestsException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, TooManyRequestsException.prototype);
        _this.retryAfterSeconds = opts.retryAfterSeconds;
        _this.Type = opts.Type;
        _this.Reason = opts.Reason;
        return _this;
    }
    return TooManyRequestsException;
}(__BaseException));
export { TooManyRequestsException };
export var FunctionUrlAuthType;
(function (FunctionUrlAuthType) {
    FunctionUrlAuthType["AWS_IAM"] = "AWS_IAM";
    FunctionUrlAuthType["NONE"] = "NONE";
})(FunctionUrlAuthType || (FunctionUrlAuthType = {}));
export var Architecture;
(function (Architecture) {
    Architecture["arm64"] = "arm64";
    Architecture["x86_64"] = "x86_64";
})(Architecture || (Architecture = {}));
export var CodeSigningPolicy;
(function (CodeSigningPolicy) {
    CodeSigningPolicy["Enforce"] = "Enforce";
    CodeSigningPolicy["Warn"] = "Warn";
})(CodeSigningPolicy || (CodeSigningPolicy = {}));
export var FunctionResponseType;
(function (FunctionResponseType) {
    FunctionResponseType["ReportBatchItemFailures"] = "ReportBatchItemFailures";
})(FunctionResponseType || (FunctionResponseType = {}));
export var EndPointType;
(function (EndPointType) {
    EndPointType["KAFKA_BOOTSTRAP_SERVERS"] = "KAFKA_BOOTSTRAP_SERVERS";
})(EndPointType || (EndPointType = {}));
export var SourceAccessType;
(function (SourceAccessType) {
    SourceAccessType["BASIC_AUTH"] = "BASIC_AUTH";
    SourceAccessType["CLIENT_CERTIFICATE_TLS_AUTH"] = "CLIENT_CERTIFICATE_TLS_AUTH";
    SourceAccessType["SASL_SCRAM_256_AUTH"] = "SASL_SCRAM_256_AUTH";
    SourceAccessType["SASL_SCRAM_512_AUTH"] = "SASL_SCRAM_512_AUTH";
    SourceAccessType["SERVER_ROOT_CA_CERTIFICATE"] = "SERVER_ROOT_CA_CERTIFICATE";
    SourceAccessType["VIRTUAL_HOST"] = "VIRTUAL_HOST";
    SourceAccessType["VPC_SECURITY_GROUP"] = "VPC_SECURITY_GROUP";
    SourceAccessType["VPC_SUBNET"] = "VPC_SUBNET";
})(SourceAccessType || (SourceAccessType = {}));
export var EventSourcePosition;
(function (EventSourcePosition) {
    EventSourcePosition["AT_TIMESTAMP"] = "AT_TIMESTAMP";
    EventSourcePosition["LATEST"] = "LATEST";
    EventSourcePosition["TRIM_HORIZON"] = "TRIM_HORIZON";
})(EventSourcePosition || (EventSourcePosition = {}));
var CodeSigningConfigNotFoundException = (function (_super) {
    __extends(CodeSigningConfigNotFoundException, _super);
    function CodeSigningConfigNotFoundException(opts) {
        var _this = _super.call(this, __assign({ name: "CodeSigningConfigNotFoundException", $fault: "client" }, opts)) || this;
        _this.name = "CodeSigningConfigNotFoundException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, CodeSigningConfigNotFoundException.prototype);
        _this.Type = opts.Type;
        _this.Message = opts.Message;
        return _this;
    }
    return CodeSigningConfigNotFoundException;
}(__BaseException));
export { CodeSigningConfigNotFoundException };
var CodeStorageExceededException = (function (_super) {
    __extends(CodeStorageExceededException, _super);
    function CodeStorageExceededException(opts) {
        var _this = _super.call(this, __assign({ name: "CodeStorageExceededException", $fault: "client" }, opts)) || this;
        _this.name = "CodeStorageExceededException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, CodeStorageExceededException.prototype);
        _this.Type = opts.Type;
        return _this;
    }
    return CodeStorageExceededException;
}(__BaseException));
export { CodeStorageExceededException };
var CodeVerificationFailedException = (function (_super) {
    __extends(CodeVerificationFailedException, _super);
    function CodeVerificationFailedException(opts) {
        var _this = _super.call(this, __assign({ name: "CodeVerificationFailedException", $fault: "client" }, opts)) || this;
        _this.name = "CodeVerificationFailedException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, CodeVerificationFailedException.prototype);
        _this.Type = opts.Type;
        _this.Message = opts.Message;
        return _this;
    }
    return CodeVerificationFailedException;
}(__BaseException));
export { CodeVerificationFailedException };
export var PackageType;
(function (PackageType) {
    PackageType["Image"] = "Image";
    PackageType["Zip"] = "Zip";
})(PackageType || (PackageType = {}));
export var Runtime;
(function (Runtime) {
    Runtime["dotnet6"] = "dotnet6";
    Runtime["dotnetcore10"] = "dotnetcore1.0";
    Runtime["dotnetcore20"] = "dotnetcore2.0";
    Runtime["dotnetcore21"] = "dotnetcore2.1";
    Runtime["dotnetcore31"] = "dotnetcore3.1";
    Runtime["go1x"] = "go1.x";
    Runtime["java11"] = "java11";
    Runtime["java8"] = "java8";
    Runtime["java8al2"] = "java8.al2";
    Runtime["nodejs"] = "nodejs";
    Runtime["nodejs10x"] = "nodejs10.x";
    Runtime["nodejs12x"] = "nodejs12.x";
    Runtime["nodejs14x"] = "nodejs14.x";
    Runtime["nodejs16x"] = "nodejs16.x";
    Runtime["nodejs43"] = "nodejs4.3";
    Runtime["nodejs43edge"] = "nodejs4.3-edge";
    Runtime["nodejs610"] = "nodejs6.10";
    Runtime["nodejs810"] = "nodejs8.10";
    Runtime["provided"] = "provided";
    Runtime["providedal2"] = "provided.al2";
    Runtime["python27"] = "python2.7";
    Runtime["python36"] = "python3.6";
    Runtime["python37"] = "python3.7";
    Runtime["python38"] = "python3.8";
    Runtime["python39"] = "python3.9";
    Runtime["ruby25"] = "ruby2.5";
    Runtime["ruby27"] = "ruby2.7";
})(Runtime || (Runtime = {}));
export var TracingMode;
(function (TracingMode) {
    TracingMode["Active"] = "Active";
    TracingMode["PassThrough"] = "PassThrough";
})(TracingMode || (TracingMode = {}));
export var LastUpdateStatus;
(function (LastUpdateStatus) {
    LastUpdateStatus["Failed"] = "Failed";
    LastUpdateStatus["InProgress"] = "InProgress";
    LastUpdateStatus["Successful"] = "Successful";
})(LastUpdateStatus || (LastUpdateStatus = {}));
export var LastUpdateStatusReasonCode;
(function (LastUpdateStatusReasonCode) {
    LastUpdateStatusReasonCode["EniLimitExceeded"] = "EniLimitExceeded";
    LastUpdateStatusReasonCode["ImageAccessDenied"] = "ImageAccessDenied";
    LastUpdateStatusReasonCode["ImageDeleted"] = "ImageDeleted";
    LastUpdateStatusReasonCode["InsufficientRolePermissions"] = "InsufficientRolePermissions";
    LastUpdateStatusReasonCode["InternalError"] = "InternalError";
    LastUpdateStatusReasonCode["InvalidConfiguration"] = "InvalidConfiguration";
    LastUpdateStatusReasonCode["InvalidImage"] = "InvalidImage";
    LastUpdateStatusReasonCode["InvalidSecurityGroup"] = "InvalidSecurityGroup";
    LastUpdateStatusReasonCode["InvalidSubnet"] = "InvalidSubnet";
    LastUpdateStatusReasonCode["SubnetOutOfIPAddresses"] = "SubnetOutOfIPAddresses";
})(LastUpdateStatusReasonCode || (LastUpdateStatusReasonCode = {}));
export var State;
(function (State) {
    State["Active"] = "Active";
    State["Failed"] = "Failed";
    State["Inactive"] = "Inactive";
    State["Pending"] = "Pending";
})(State || (State = {}));
export var StateReasonCode;
(function (StateReasonCode) {
    StateReasonCode["Creating"] = "Creating";
    StateReasonCode["EniLimitExceeded"] = "EniLimitExceeded";
    StateReasonCode["Idle"] = "Idle";
    StateReasonCode["ImageAccessDenied"] = "ImageAccessDenied";
    StateReasonCode["ImageDeleted"] = "ImageDeleted";
    StateReasonCode["InsufficientRolePermissions"] = "InsufficientRolePermissions";
    StateReasonCode["InternalError"] = "InternalError";
    StateReasonCode["InvalidConfiguration"] = "InvalidConfiguration";
    StateReasonCode["InvalidImage"] = "InvalidImage";
    StateReasonCode["InvalidSecurityGroup"] = "InvalidSecurityGroup";
    StateReasonCode["InvalidSubnet"] = "InvalidSubnet";
    StateReasonCode["Restoring"] = "Restoring";
    StateReasonCode["SubnetOutOfIPAddresses"] = "SubnetOutOfIPAddresses";
})(StateReasonCode || (StateReasonCode = {}));
var InvalidCodeSignatureException = (function (_super) {
    __extends(InvalidCodeSignatureException, _super);
    function InvalidCodeSignatureException(opts) {
        var _this = _super.call(this, __assign({ name: "InvalidCodeSignatureException", $fault: "client" }, opts)) || this;
        _this.name = "InvalidCodeSignatureException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, InvalidCodeSignatureException.prototype);
        _this.Type = opts.Type;
        _this.Message = opts.Message;
        return _this;
    }
    return InvalidCodeSignatureException;
}(__BaseException));
export { InvalidCodeSignatureException };
var ResourceInUseException = (function (_super) {
    __extends(ResourceInUseException, _super);
    function ResourceInUseException(opts) {
        var _this = _super.call(this, __assign({ name: "ResourceInUseException", $fault: "client" }, opts)) || this;
        _this.name = "ResourceInUseException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, ResourceInUseException.prototype);
        _this.Type = opts.Type;
        _this.Message = opts.Message;
        return _this;
    }
    return ResourceInUseException;
}(__BaseException));
export { ResourceInUseException };
export var ProvisionedConcurrencyStatusEnum;
(function (ProvisionedConcurrencyStatusEnum) {
    ProvisionedConcurrencyStatusEnum["FAILED"] = "FAILED";
    ProvisionedConcurrencyStatusEnum["IN_PROGRESS"] = "IN_PROGRESS";
    ProvisionedConcurrencyStatusEnum["READY"] = "READY";
})(ProvisionedConcurrencyStatusEnum || (ProvisionedConcurrencyStatusEnum = {}));
var ProvisionedConcurrencyConfigNotFoundException = (function (_super) {
    __extends(ProvisionedConcurrencyConfigNotFoundException, _super);
    function ProvisionedConcurrencyConfigNotFoundException(opts) {
        var _this = _super.call(this, __assign({ name: "ProvisionedConcurrencyConfigNotFoundException", $fault: "client" }, opts)) || this;
        _this.name = "ProvisionedConcurrencyConfigNotFoundException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, ProvisionedConcurrencyConfigNotFoundException.prototype);
        _this.Type = opts.Type;
        return _this;
    }
    return ProvisionedConcurrencyConfigNotFoundException;
}(__BaseException));
export { ProvisionedConcurrencyConfigNotFoundException };
var EC2AccessDeniedException = (function (_super) {
    __extends(EC2AccessDeniedException, _super);
    function EC2AccessDeniedException(opts) {
        var _this = _super.call(this, __assign({ name: "EC2AccessDeniedException", $fault: "server" }, opts)) || this;
        _this.name = "EC2AccessDeniedException";
        _this.$fault = "server";
        Object.setPrototypeOf(_this, EC2AccessDeniedException.prototype);
        _this.Type = opts.Type;
        _this.Message = opts.Message;
        return _this;
    }
    return EC2AccessDeniedException;
}(__BaseException));
export { EC2AccessDeniedException };
var EC2ThrottledException = (function (_super) {
    __extends(EC2ThrottledException, _super);
    function EC2ThrottledException(opts) {
        var _this = _super.call(this, __assign({ name: "EC2ThrottledException", $fault: "server" }, opts)) || this;
        _this.name = "EC2ThrottledException";
        _this.$fault = "server";
        Object.setPrototypeOf(_this, EC2ThrottledException.prototype);
        _this.Type = opts.Type;
        _this.Message = opts.Message;
        return _this;
    }
    return EC2ThrottledException;
}(__BaseException));
export { EC2ThrottledException };
var EC2UnexpectedException = (function (_super) {
    __extends(EC2UnexpectedException, _super);
    function EC2UnexpectedException(opts) {
        var _this = _super.call(this, __assign({ name: "EC2UnexpectedException", $fault: "server" }, opts)) || this;
        _this.name = "EC2UnexpectedException";
        _this.$fault = "server";
        Object.setPrototypeOf(_this, EC2UnexpectedException.prototype);
        _this.Type = opts.Type;
        _this.Message = opts.Message;
        _this.EC2ErrorCode = opts.EC2ErrorCode;
        return _this;
    }
    return EC2UnexpectedException;
}(__BaseException));
export { EC2UnexpectedException };
var EFSIOException = (function (_super) {
    __extends(EFSIOException, _super);
    function EFSIOException(opts) {
        var _this = _super.call(this, __assign({ name: "EFSIOException", $fault: "client" }, opts)) || this;
        _this.name = "EFSIOException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, EFSIOException.prototype);
        _this.Type = opts.Type;
        _this.Message = opts.Message;
        return _this;
    }
    return EFSIOException;
}(__BaseException));
export { EFSIOException };
var EFSMountConnectivityException = (function (_super) {
    __extends(EFSMountConnectivityException, _super);
    function EFSMountConnectivityException(opts) {
        var _this = _super.call(this, __assign({ name: "EFSMountConnectivityException", $fault: "client" }, opts)) || this;
        _this.name = "EFSMountConnectivityException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, EFSMountConnectivityException.prototype);
        _this.Type = opts.Type;
        _this.Message = opts.Message;
        return _this;
    }
    return EFSMountConnectivityException;
}(__BaseException));
export { EFSMountConnectivityException };
var EFSMountFailureException = (function (_super) {
    __extends(EFSMountFailureException, _super);
    function EFSMountFailureException(opts) {
        var _this = _super.call(this, __assign({ name: "EFSMountFailureException", $fault: "client" }, opts)) || this;
        _this.name = "EFSMountFailureException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, EFSMountFailureException.prototype);
        _this.Type = opts.Type;
        _this.Message = opts.Message;
        return _this;
    }
    return EFSMountFailureException;
}(__BaseException));
export { EFSMountFailureException };
var EFSMountTimeoutException = (function (_super) {
    __extends(EFSMountTimeoutException, _super);
    function EFSMountTimeoutException(opts) {
        var _this = _super.call(this, __assign({ name: "EFSMountTimeoutException", $fault: "client" }, opts)) || this;
        _this.name = "EFSMountTimeoutException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, EFSMountTimeoutException.prototype);
        _this.Type = opts.Type;
        _this.Message = opts.Message;
        return _this;
    }
    return EFSMountTimeoutException;
}(__BaseException));
export { EFSMountTimeoutException };
var ENILimitReachedException = (function (_super) {
    __extends(ENILimitReachedException, _super);
    function ENILimitReachedException(opts) {
        var _this = _super.call(this, __assign({ name: "ENILimitReachedException", $fault: "server" }, opts)) || this;
        _this.name = "ENILimitReachedException";
        _this.$fault = "server";
        Object.setPrototypeOf(_this, ENILimitReachedException.prototype);
        _this.Type = opts.Type;
        _this.Message = opts.Message;
        return _this;
    }
    return ENILimitReachedException;
}(__BaseException));
export { ENILimitReachedException };
var InvalidRequestContentException = (function (_super) {
    __extends(InvalidRequestContentException, _super);
    function InvalidRequestContentException(opts) {
        var _this = _super.call(this, __assign({ name: "InvalidRequestContentException", $fault: "client" }, opts)) || this;
        _this.name = "InvalidRequestContentException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, InvalidRequestContentException.prototype);
        _this.Type = opts.Type;
        return _this;
    }
    return InvalidRequestContentException;
}(__BaseException));
export { InvalidRequestContentException };
var InvalidRuntimeException = (function (_super) {
    __extends(InvalidRuntimeException, _super);
    function InvalidRuntimeException(opts) {
        var _this = _super.call(this, __assign({ name: "InvalidRuntimeException", $fault: "server" }, opts)) || this;
        _this.name = "InvalidRuntimeException";
        _this.$fault = "server";
        Object.setPrototypeOf(_this, InvalidRuntimeException.prototype);
        _this.Type = opts.Type;
        _this.Message = opts.Message;
        return _this;
    }
    return InvalidRuntimeException;
}(__BaseException));
export { InvalidRuntimeException };
var InvalidSecurityGroupIDException = (function (_super) {
    __extends(InvalidSecurityGroupIDException, _super);
    function InvalidSecurityGroupIDException(opts) {
        var _this = _super.call(this, __assign({ name: "InvalidSecurityGroupIDException", $fault: "server" }, opts)) || this;
        _this.name = "InvalidSecurityGroupIDException";
        _this.$fault = "server";
        Object.setPrototypeOf(_this, InvalidSecurityGroupIDException.prototype);
        _this.Type = opts.Type;
        _this.Message = opts.Message;
        return _this;
    }
    return InvalidSecurityGroupIDException;
}(__BaseException));
export { InvalidSecurityGroupIDException };
var InvalidSubnetIDException = (function (_super) {
    __extends(InvalidSubnetIDException, _super);
    function InvalidSubnetIDException(opts) {
        var _this = _super.call(this, __assign({ name: "InvalidSubnetIDException", $fault: "server" }, opts)) || this;
        _this.name = "InvalidSubnetIDException";
        _this.$fault = "server";
        Object.setPrototypeOf(_this, InvalidSubnetIDException.prototype);
        _this.Type = opts.Type;
        _this.Message = opts.Message;
        return _this;
    }
    return InvalidSubnetIDException;
}(__BaseException));
export { InvalidSubnetIDException };
var InvalidZipFileException = (function (_super) {
    __extends(InvalidZipFileException, _super);
    function InvalidZipFileException(opts) {
        var _this = _super.call(this, __assign({ name: "InvalidZipFileException", $fault: "server" }, opts)) || this;
        _this.name = "InvalidZipFileException";
        _this.$fault = "server";
        Object.setPrototypeOf(_this, InvalidZipFileException.prototype);
        _this.Type = opts.Type;
        _this.Message = opts.Message;
        return _this;
    }
    return InvalidZipFileException;
}(__BaseException));
export { InvalidZipFileException };
export var InvocationType;
(function (InvocationType) {
    InvocationType["DryRun"] = "DryRun";
    InvocationType["Event"] = "Event";
    InvocationType["RequestResponse"] = "RequestResponse";
})(InvocationType || (InvocationType = {}));
export var LogType;
(function (LogType) {
    LogType["None"] = "None";
    LogType["Tail"] = "Tail";
})(LogType || (LogType = {}));
var KMSAccessDeniedException = (function (_super) {
    __extends(KMSAccessDeniedException, _super);
    function KMSAccessDeniedException(opts) {
        var _this = _super.call(this, __assign({ name: "KMSAccessDeniedException", $fault: "server" }, opts)) || this;
        _this.name = "KMSAccessDeniedException";
        _this.$fault = "server";
        Object.setPrototypeOf(_this, KMSAccessDeniedException.prototype);
        _this.Type = opts.Type;
        _this.Message = opts.Message;
        return _this;
    }
    return KMSAccessDeniedException;
}(__BaseException));
export { KMSAccessDeniedException };
var KMSDisabledException = (function (_super) {
    __extends(KMSDisabledException, _super);
    function KMSDisabledException(opts) {
        var _this = _super.call(this, __assign({ name: "KMSDisabledException", $fault: "server" }, opts)) || this;
        _this.name = "KMSDisabledException";
        _this.$fault = "server";
        Object.setPrototypeOf(_this, KMSDisabledException.prototype);
        _this.Type = opts.Type;
        _this.Message = opts.Message;
        return _this;
    }
    return KMSDisabledException;
}(__BaseException));
export { KMSDisabledException };
var KMSInvalidStateException = (function (_super) {
    __extends(KMSInvalidStateException, _super);
    function KMSInvalidStateException(opts) {
        var _this = _super.call(this, __assign({ name: "KMSInvalidStateException", $fault: "server" }, opts)) || this;
        _this.name = "KMSInvalidStateException";
        _this.$fault = "server";
        Object.setPrototypeOf(_this, KMSInvalidStateException.prototype);
        _this.Type = opts.Type;
        _this.Message = opts.Message;
        return _this;
    }
    return KMSInvalidStateException;
}(__BaseException));
export { KMSInvalidStateException };
var KMSNotFoundException = (function (_super) {
    __extends(KMSNotFoundException, _super);
    function KMSNotFoundException(opts) {
        var _this = _super.call(this, __assign({ name: "KMSNotFoundException", $fault: "server" }, opts)) || this;
        _this.name = "KMSNotFoundException";
        _this.$fault = "server";
        Object.setPrototypeOf(_this, KMSNotFoundException.prototype);
        _this.Type = opts.Type;
        _this.Message = opts.Message;
        return _this;
    }
    return KMSNotFoundException;
}(__BaseException));
export { KMSNotFoundException };
var RequestTooLargeException = (function (_super) {
    __extends(RequestTooLargeException, _super);
    function RequestTooLargeException(opts) {
        var _this = _super.call(this, __assign({ name: "RequestTooLargeException", $fault: "client" }, opts)) || this;
        _this.name = "RequestTooLargeException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, RequestTooLargeException.prototype);
        _this.Type = opts.Type;
        return _this;
    }
    return RequestTooLargeException;
}(__BaseException));
export { RequestTooLargeException };
var ResourceNotReadyException = (function (_super) {
    __extends(ResourceNotReadyException, _super);
    function ResourceNotReadyException(opts) {
        var _this = _super.call(this, __assign({ name: "ResourceNotReadyException", $fault: "server" }, opts)) || this;
        _this.name = "ResourceNotReadyException";
        _this.$fault = "server";
        Object.setPrototypeOf(_this, ResourceNotReadyException.prototype);
        _this.Type = opts.Type;
        return _this;
    }
    return ResourceNotReadyException;
}(__BaseException));
export { ResourceNotReadyException };
var SubnetIPAddressLimitReachedException = (function (_super) {
    __extends(SubnetIPAddressLimitReachedException, _super);
    function SubnetIPAddressLimitReachedException(opts) {
        var _this = _super.call(this, __assign({ name: "SubnetIPAddressLimitReachedException", $fault: "server" }, opts)) || this;
        _this.name = "SubnetIPAddressLimitReachedException";
        _this.$fault = "server";
        Object.setPrototypeOf(_this, SubnetIPAddressLimitReachedException.prototype);
        _this.Type = opts.Type;
        _this.Message = opts.Message;
        return _this;
    }
    return SubnetIPAddressLimitReachedException;
}(__BaseException));
export { SubnetIPAddressLimitReachedException };
var UnsupportedMediaTypeException = (function (_super) {
    __extends(UnsupportedMediaTypeException, _super);
    function UnsupportedMediaTypeException(opts) {
        var _this = _super.call(this, __assign({ name: "UnsupportedMediaTypeException", $fault: "client" }, opts)) || this;
        _this.name = "UnsupportedMediaTypeException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, UnsupportedMediaTypeException.prototype);
        _this.Type = opts.Type;
        return _this;
    }
    return UnsupportedMediaTypeException;
}(__BaseException));
export { UnsupportedMediaTypeException };
export var FunctionVersion;
(function (FunctionVersion) {
    FunctionVersion["ALL"] = "ALL";
})(FunctionVersion || (FunctionVersion = {}));
export var AccountLimitFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var AccountUsageFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var AddLayerVersionPermissionRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var AddLayerVersionPermissionResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var AddPermissionRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var AddPermissionResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var AliasRoutingConfigurationFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var AliasConfigurationFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var AllowedPublishersFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var AmazonManagedKafkaEventSourceConfigFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CreateAliasRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CodeSigningPoliciesFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CreateCodeSigningConfigRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CodeSigningConfigFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CreateCodeSigningConfigResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var OnFailureFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var OnSuccessFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DestinationConfigFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var FilterFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var FilterCriteriaFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var SelfManagedEventSourceFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var SelfManagedKafkaEventSourceConfigFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var SourceAccessConfigurationFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CreateEventSourceMappingRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var EventSourceMappingConfigurationFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var FunctionCodeFilterSensitiveLog = function (obj) { return (__assign(__assign({}, obj), (obj.ZipFile && { ZipFile: SENSITIVE_STRING }))); };
export var DeadLetterConfigFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var EnvironmentFilterSensitiveLog = function (obj) { return (__assign(__assign({}, obj), (obj.Variables && { Variables: SENSITIVE_STRING }))); };
export var EphemeralStorageFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var FileSystemConfigFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ImageConfigFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var TracingConfigFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var VpcConfigFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CreateFunctionRequestFilterSensitiveLog = function (obj) { return (__assign(__assign(__assign({}, obj), (obj.Code && { Code: FunctionCodeFilterSensitiveLog(obj.Code) })), (obj.Environment && { Environment: EnvironmentFilterSensitiveLog(obj.Environment) }))); };
export var EnvironmentErrorFilterSensitiveLog = function (obj) { return (__assign(__assign({}, obj), (obj.Message && { Message: SENSITIVE_STRING }))); };
export var EnvironmentResponseFilterSensitiveLog = function (obj) { return (__assign(__assign(__assign({}, obj), (obj.Variables && { Variables: SENSITIVE_STRING })), (obj.Error && { Error: EnvironmentErrorFilterSensitiveLog(obj.Error) }))); };
export var ImageConfigErrorFilterSensitiveLog = function (obj) { return (__assign(__assign({}, obj), (obj.Message && { Message: SENSITIVE_STRING }))); };
export var ImageConfigResponseFilterSensitiveLog = function (obj) { return (__assign(__assign({}, obj), (obj.Error && { Error: ImageConfigErrorFilterSensitiveLog(obj.Error) }))); };
export var LayerFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var TracingConfigResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var VpcConfigResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var FunctionConfigurationFilterSensitiveLog = function (obj) { return (__assign(__assign(__assign({}, obj), (obj.Environment && { Environment: EnvironmentResponseFilterSensitiveLog(obj.Environment) })), (obj.ImageConfigResponse && {
    ImageConfigResponse: ImageConfigResponseFilterSensitiveLog(obj.ImageConfigResponse),
}))); };
export var CorsFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CreateFunctionUrlConfigRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CreateFunctionUrlConfigResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DeleteAliasRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DeleteCodeSigningConfigRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DeleteCodeSigningConfigResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DeleteEventSourceMappingRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DeleteFunctionRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DeleteFunctionCodeSigningConfigRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DeleteFunctionConcurrencyRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DeleteFunctionEventInvokeConfigRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DeleteFunctionUrlConfigRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DeleteLayerVersionRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DeleteProvisionedConcurrencyConfigRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetAccountSettingsRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetAccountSettingsResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetAliasRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetCodeSigningConfigRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetCodeSigningConfigResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetEventSourceMappingRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetFunctionRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var FunctionCodeLocationFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ConcurrencyFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetFunctionResponseFilterSensitiveLog = function (obj) { return (__assign(__assign({}, obj), (obj.Configuration && { Configuration: FunctionConfigurationFilterSensitiveLog(obj.Configuration) }))); };
export var GetFunctionCodeSigningConfigRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetFunctionCodeSigningConfigResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetFunctionConcurrencyRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetFunctionConcurrencyResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetFunctionConfigurationRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var FunctionEventInvokeConfigFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetFunctionEventInvokeConfigRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetFunctionUrlConfigRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetFunctionUrlConfigResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetLayerVersionRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var LayerVersionContentOutputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetLayerVersionResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetLayerVersionByArnRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetLayerVersionPolicyRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetLayerVersionPolicyResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetPolicyRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetPolicyResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetProvisionedConcurrencyConfigRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetProvisionedConcurrencyConfigResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var InvocationRequestFilterSensitiveLog = function (obj) { return (__assign(__assign({}, obj), (obj.Payload && { Payload: SENSITIVE_STRING }))); };
export var InvocationResponseFilterSensitiveLog = function (obj) { return (__assign(__assign({}, obj), (obj.Payload && { Payload: SENSITIVE_STRING }))); };
export var InvokeAsyncRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var InvokeAsyncResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ListAliasesRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ListAliasesResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ListCodeSigningConfigsRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ListCodeSigningConfigsResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ListEventSourceMappingsRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ListEventSourceMappingsResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ListFunctionEventInvokeConfigsRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ListFunctionEventInvokeConfigsResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ListFunctionsRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ListFunctionsResponseFilterSensitiveLog = function (obj) { return (__assign(__assign({}, obj), (obj.Functions && { Functions: obj.Functions.map(function (item) { return FunctionConfigurationFilterSensitiveLog(item); }) }))); };
export var ListFunctionsByCodeSigningConfigRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ListFunctionsByCodeSigningConfigResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ListFunctionUrlConfigsRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var FunctionUrlConfigFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ListFunctionUrlConfigsResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ListLayersRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var LayerVersionsListItemFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var LayersListItemFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ListLayersResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ListLayerVersionsRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ListLayerVersionsResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ListProvisionedConcurrencyConfigsRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ProvisionedConcurrencyConfigListItemFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ListProvisionedConcurrencyConfigsResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ListTagsRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ListTagsResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ListVersionsByFunctionRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ListVersionsByFunctionResponseFilterSensitiveLog = function (obj) { return (__assign(__assign({}, obj), (obj.Versions && { Versions: obj.Versions.map(function (item) { return FunctionConfigurationFilterSensitiveLog(item); }) }))); };
export var LayerVersionContentInputFilterSensitiveLog = function (obj) { return (__assign(__assign({}, obj), (obj.ZipFile && { ZipFile: SENSITIVE_STRING }))); };
export var PublishLayerVersionRequestFilterSensitiveLog = function (obj) { return (__assign(__assign({}, obj), (obj.Content && { Content: LayerVersionContentInputFilterSensitiveLog(obj.Content) }))); };
export var PublishLayerVersionResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var PublishVersionRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var PutFunctionCodeSigningConfigRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var PutFunctionCodeSigningConfigResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var PutFunctionConcurrencyRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var PutFunctionEventInvokeConfigRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var PutProvisionedConcurrencyConfigRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var PutProvisionedConcurrencyConfigResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var RemoveLayerVersionPermissionRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var RemovePermissionRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var TagResourceRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var UntagResourceRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var UpdateAliasRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var UpdateCodeSigningConfigRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var UpdateCodeSigningConfigResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var UpdateEventSourceMappingRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var UpdateFunctionCodeRequestFilterSensitiveLog = function (obj) { return (__assign(__assign({}, obj), (obj.ZipFile && { ZipFile: SENSITIVE_STRING }))); };
export var UpdateFunctionConfigurationRequestFilterSensitiveLog = function (obj) { return (__assign(__assign({}, obj), (obj.Environment && { Environment: EnvironmentFilterSensitiveLog(obj.Environment) }))); };
export var UpdateFunctionEventInvokeConfigRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var UpdateFunctionUrlConfigRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var UpdateFunctionUrlConfigResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
